<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="typewriter">
    <h1>Welcome to College Management System..</h1>
  </div>
</div>
